  const riasNotification = document.querySelector('.rias-notification');
  const yaoiNotificationNew = document.querySelector('.yaoi-notification');
  const newTopBar = document.querySelector('.new-top-bar');
  const topBarArrows = document.querySelectorAll('.slider-arrow');
  const body = document.querySelector('body');
  const html = document.querySelector('html');

  if (riasNotification) {
  riasNotification.addEventListener('click', () => {
    newTopBar.classList.toggle('hide-dropdown');
    newTopBar.classList.toggle('hide-dropdown-yaoi');
    body.classList.toggle('disable-scroll');
    html.classList.toggle('disable-scroll');
    document.querySelector('.rias-notification').classList.remove('animation');
    //window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  }

  if (yaoiNotificationNew) {
  yaoiNotificationNew.addEventListener('click', () => {
    newTopBar.classList.toggle('hide-dropdown');
    newTopBar.classList.toggle('hide-dropdown-yaoi');
    body.classList.toggle('disable-scroll');
    html.classList.toggle('disable-scroll');
    document.querySelector('.rias-notification').classList.remove('animation');
    // window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  }

  topBarArrows.forEach(topBarArrow => {
  topBarArrow.addEventListener('click', () => {
    newTopBar.classList.add('hide-dropdown');
    newTopBar.classList.toggle('hide-dropdown-yaoi');
    body.classList.remove('disable-scroll');
    html.classList.remove('disable-scroll');
  });
});


(function () {
  let actionTriggered = false;

  window.addEventListener('scroll', function () {
    if (actionTriggered) return;

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;

    if (scrollPercent >= 50) {
      actionTriggered = true; // Prevent future triggers

      const body = document.body;
      if (!body.classList.contains('disable-scroll')) {
        const notification = document.querySelector('#ecchiNotification');
        if (notification) {
          notification.click();
        }
      } else {
        //window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  });
})();



  // Function to add the "animation" class
  function addAnimationClass() {
    const element = document.querySelector('.rias-notification'); // Select the element with the "rias-notification" class
    element.classList.add('animation');

    // Remove the "animation" class after 10 seconds
    setTimeout(() => {
      element.classList.remove('animation');
    }, 10000); // 10,000 milliseconds = 10 seconds

    //const element2 = document.querySelector('.yaoi-notification'); // Select the element with the "rias-notification" class
    //element2.classList.add('animation');

    // Remove the "animation" class after 10 seconds
    setTimeout(() => {
      //element2.classList.remove('animation');
    }, 10000); // 10,000 milliseconds = 10 seconds
  }

  var classAdded = false;

  // Function to check if the user has scrolled 50% of the page
  function checkScrollPosition() {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const pageHeight = document.body.scrollHeight;
    const riasNotification = document.querySelector('.rias-notification');
    const yaoiNotificationNew = document.querySelector('.yaoi-notification');

    if ( (scrollPosition > 0.5 * (pageHeight - windowHeight)) && ( classAdded == false ) ) {
      if ( (riasNotification) || (yaoiNotificationNew) ) {
        addAnimationClass();
      }
      classAdded = true;
    }
  }

  // Add scroll event listener to check scroll position
  window.addEventListener('scroll', checkScrollPosition);

  // Function to add the "animation" class after 30 seconds
  function addAnimationAfter30Seconds() {
    if ( classAdded == false ) {
      setTimeout(addAnimationClass, 30000); // 30,000 milliseconds = 30 seconds
    }
  }

  // Add the "animation" class after 30 seconds
  addAnimationAfter30Seconds();


function fadeIn(el, duration) {
    var target = document.querySelector(el);
    if ( target !== null ) {
      var currentOpacity = 0;
      var increment = 1/(duration/10);
      target.classList.add("show-sidebar");
      var interval = setInterval(function() {
        currentOpacity += increment;
        target.style.opacity = currentOpacity;
        if (currentOpacity >= 1) {
          target.style.opacity = 1;
          clearInterval(interval);
        }
      }, 10);
    }
  }
  function fadeOut(el, duration) {
    var target = document.querySelector(el);
    if ( target !== null ) {
      var currentOpacity = 1;
      var increment = 1/(duration/10);
      var interval = setInterval(function() {
        currentOpacity -= increment;
        target.style.opacity = currentOpacity;
        if (currentOpacity <= 0) {
          target.style.opacity = 0;
          clearInterval(interval);
          target.classList.remove("show-sidebar");
        }
      }, 10);
    }
  }
  var hasFadedIn = false;

  /*document.addEventListener('scroll', function() {
    var y = window.scrollY;
    if (y > window.innerHeight*1.5) {
      if (!hasFadedIn) {
        fadeIn('.tf-v1-sidetab', 500);
        hasFadedIn = true;
      }
    } else {
      if (hasFadedIn) {
          fadeOut('.tf-v1-sidetab', 500);
          hasFadedIn = false;
      }
    }
  });*/

  const initialiseStyleBackgroundIntersectionObserver = () => {
  const lazyBackgrounds = Array.from(document.querySelectorAll('[data-background-image]'));

  if (lazyBackgrounds.length === 0) {
    return;
  }

  let lazyBackgroundObserver;

  const loadBackgroundIfElementOnScreen = (entry) => {
    if (entry.isIntersecting) {
      entry.target.style.backgroundImage = `url('${entry.target.dataset.backgroundImage}')`;
      lazyBackgroundObserver.unobserve(entry.target);
    }
  };

  const observeElementVisibility = (lazyBackground) => {
    lazyBackgroundObserver.observe(lazyBackground);
  };

  const setBackground = (element) => {
    element.style.backgroundImage = `url('${entry.target.dataset.backgroundImage}')`;
  };

  if (typeof window.IntersectionObserver === 'function') {
    lazyBackgroundObserver = new IntersectionObserver((entries) => {
      entries.forEach(loadBackgroundIfElementOnScreen);
    });
    lazyBackgrounds.forEach(observeElementVisibility);
  } else {
    lazyBackgrounds.forEach(setBackground);
  }
};

if (typeof document.readyState === 'string' && document.readyState === 'complete') {
  initialiseStyleBackgroundIntersectionObserver();
} else {
  document.addEventListener('DOMContentLoaded', initialiseStyleBackgroundIntersectionObserver, true);
}

/*My sponsorships & partnerships*/
function initializeSlider() {
  $('.sponsorship-slider').slick({
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    prevArrow: '<span class="arrows"><svg width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path id="Vector" d="M39.5 8L1.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
    nextArrow: '<span class="arrows"><svg width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path id="Vector" d="M0.5 8L38.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M31.5 1L38.5 8L31.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
    slidesToShow: 8,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1224,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: "unslick"
      }
    ]
  });
}

// Function to initialize or destroy the slider based on screen width
function checkSlider() {
  if (window.matchMedia('(max-width: 767px)').matches) {
    $('.sponsorship-slider').slick('unslick');
  } else {
    initializeSlider();
  }
}

// Initialize slider on document ready
$(document).ready(function() {
  checkSlider();
});

// Re-initialize slider on window resize
$(window).resize(function() {
  checkSlider();
});

$('.past-boxes-slider-2').slick({
  dots: false,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 3000,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1119,
      settings: {
        slidesToShow: 5,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 3,
      }
    }
  ]
});

$('.past-boxes-slider').slick({
  dots: false,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 3000,
  prevArrow: '<span class="arrows"><svg width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path id="Vector" d="M39.5 8L1.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  nextArrow: '<span class="arrows"><svg width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path id="Vector" d="M0.5 8L38.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M31.5 1L38.5 8L31.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1119,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
});

$('.past-boxes-yaoi-slider').slick({
  dots: false,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 3000,
  prevArrow: '<span class="arrows"><svg width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path id="Vector" d="M39.5 8L1.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  nextArrow: '<span class="arrows"><svg width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path id="Vector" d="M0.5 8L38.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M31.5 1L38.5 8L31.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1119,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
});


$('.reviews-slider').slick({
  dots: false,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 3000,
  prevArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M39.5 8L1.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  nextArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M0.5 8L38.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M31.5 1L38.5 8L31.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.video-slider').slick({
  dots: true,
  infinite: true,
  arrows: false,
  autoplay: false,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1
});

// Get the faqs
var faqBtn = document.querySelectorAll('[data-faq]');

// When the user clicks the button, open the modal 
for (let i = 0; i < faqBtn.length; i++) {
  faqBtn[i].onclick = function() {
  var targetFaq = faqBtn[i].getAttribute('target-faq');
  var faq = document.getElementById(targetFaq);
  faq.classList.toggle("hide");
}
}

/*Sticky Header*/
var header = document.getElementById("landingHeader");
var sticky = header.offsetTop;
function stickyFunc() {
  if (window.pageYOffset > (sticky + 0)) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}
stickyFunc()
window.onscroll = function() {stickyFunc()};

// Get the modal
var modals = document.querySelectorAll('.modal')
  
var modalClose = document.querySelectorAll('.modal .close')
var modalBoxClose = document.querySelectorAll('.modal .close-box')

// Get the button that opens the modal
var modalBtn = document.querySelectorAll('[data-modal]');
var modalBoxBtn = document.querySelectorAll('[data-box-modal]');

// When the user clicks the button, open the modal 
for (let i = 0; i < modalBtn.length; i++) {
  modalBtn[i].onclick = function() {
  var targetModal = modalBtn[i].getAttribute('target-modal');
  var modal = document.getElementById(targetModal);
  modal.style.display = "flex";
  document.body.classList.add('modal-open');
	  
  var targetDataSource = modalBtn[i].getAttribute('data-source');
  var targetDataVideo = modalBtn[i].getAttribute('data-video');
  
  if (targetDataSource === 'youtube') {
	if (document.querySelector('script[src="https://www.youtube.com/player_api"]') === null) {
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/player_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
	//var data_video = param.getAttribute('data-video');
	var player;
	function onYouTubePlayerAPIReady(id) {
		player = new YT.Player(id, {
			videoId: id.split('-')[0],
			playerVars: {
				'autoplay': 1,
				'showinfo': 0
			}
		});
	}
	document.querySelector('.video-holder').setAttribute('id',targetDataVideo)
	setTimeout(function() {
		onYouTubePlayerAPIReady(targetDataVideo);
	}, 1000)
  } else if (targetDataSource === 'shopify') {
	  	var hostedVideo = document.createElement('video');
		hostedVideo.src = targetDataVideo;
	  	hostedVideo.setAttribute("controls", "controls");
	    document.querySelector('.video-holder').appendChild(hostedVideo);
		hostedVideo.autoplay = true;
  }
}
}

function setupModalBox() {
  if (window.innerWidth > 767) {
    for (let i = 0; i < modalBoxBtn.length; i++) {
      modalBoxBtn[i].onclick = function() {
        var targetModal = modalBoxBtn[i].getAttribute('target-modal');
        var modal = document.getElementById(targetModal);
        modal.style.display = "flex";
        document.body.classList.add('modal-open');

        var targetDataImage = modalBoxBtn[i].getAttribute('data-image');

        var hostedImage = document.createElement('img');
        hostedImage.src = targetDataImage;
        document.querySelector('.box-holder').appendChild(hostedImage);
      }
    }
  } else {
    // If the screen is smaller than 767px, you might want to remove any existing click event handlers
    // and hide any displayed modals.
    for (let i = 0; i < modalBoxBtn.length; i++) {
      modalBoxBtn[i].onclick = null;
    }
  }
}

// Call the setup function when the page loads
window.addEventListener('load', setupModalBox);

// Call the setup function when the window is resized
window.addEventListener('resize', setupModalBox);

// When the user clicks on <span> (x), close the modal  
for (let i = 0; i < modalClose.length; i++) {
modalClose[i].onclick = function() {
  var closeTargetModal = modalClose[i].getAttribute('target-modal');
  var closeModal = document.getElementById(closeTargetModal);
  closeModal.style.display = "none";
  document.body.classList.remove('modal-open');
  document.querySelector('.video-holder').remove();
  var videoHolder = document.createElement("div");
  videoHolder.classList.add('video-holder') 
  document.querySelector('#videoModal .modal-content').appendChild(videoHolder);
}
} 

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  for (let i = 0; i < modals.length; i++) {
    if ( (event.target == modals[i]) || (event.target.className == "modal-content") ) {
      modals[i].style.display = "none";
      
      document.body.classList.remove('modal-open');
	  document.querySelector('.video-holder').remove();
	  var videoHolder = document.createElement("div");
	  videoHolder.classList.add('video-holder') 
	  document.querySelector('#videoModal .modal-content').appendChild(videoHolder);

      document.querySelector('.box-holder').remove();
      var boxHolder = document.createElement("div");
      boxHolder.classList.add('box-holder') 
      document.querySelector('#boxModal .modal-content').appendChild(boxHolder);

    }
  }
}

// When the user clicks on <span> (x), close the modal  
for (let i = 0; i < modalBoxClose.length; i++) {
modalBoxClose[i].onclick = function() {
  var closeTargetModal = modalBoxClose[i].getAttribute('target-modal');
  var closeModal = document.getElementById(closeTargetModal);
  closeModal.style.display = "none";
  document.body.classList.remove('modal-open');
  document.querySelector('.box-holder').remove();
  var boxHolder = document.createElement("div");
  boxHolder.classList.add('box-holder') 
  document.querySelector('#boxModal .modal-content').appendChild(boxHolder);
}
} 

function openRefundFAQ() {
    $('.faq-box h4[target-faq="faq9"]').click()
    var offSet = 100;
    if (window.matchMedia('(max-width: 767px)').matches) {
        offSet = 100;
    }
    $('html, body').animate({
        scrollTop: $('.faq-box h4[target-faq="faq9"]').offset().top - offSet
    }, 1000);
}

function checkWidth() {
  if ($(window).width() <= 767) {
    $(".nw-product-details-holder").hide();
  }
}

$(document).ready(function() {
  checkWidth(); // Check on initial load
  $(window).resize(checkWidth); // Check on window resize

  $(".nw-product-red").click(function(){
     if ($(window).width() <= 767) {
       $(".nw-product-details-holder").hide();
     }
     $(this).closest(".nw-product-indicator-holder").find(".nw-product-details-holder").show();
     event.stopPropagation(); // To prevent the click from propagating to document
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.nw-product-indicator-holder').length && $(window).width() <= 767) {
      $(".nw-product-details-holder").hide();
    }
  });
});

// Function to set a cookie
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
// Function to get a cookie value
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

const modeToggle = document.getElementById('modeToggle');
const switch_body = document.body;
const switch_page = document.querySelector(".dark-version");

// Check if a mode cookie exists and set the mode accordingly
const savedMode = getCookie('mode');
if (savedMode === 'light') {
  switch_body.classList.add('light-version-body');
  switch_page.classList.add('light-version');
  modeToggle.checked = true;
}






/*==================Jquery Cookie Start===========*/
   	 (function(factory) {
   		 if (typeof define === 'function' && define.amd) {
       		 // AMD (Register as an anonymous module)
       		 define(['jquery'], factory);
   		 } else if (typeof exports === 'object') {
       		 // Node/CommonJS
       		 module.exports = factory(require('jquery'));
   		 } else {
       		 // Browser globals
       		 factory(jQuery);
   		 }
   	 }(function($) {
   		 var pluses = /\+/g;
   		 function encode(s) {
       		 return config.raw ? s : encodeURIComponent(s);
   		 }
   		 function decode(s) {
       		 return config.raw ? s : decodeURIComponent(s);
   		 }
   		 function stringifyCookieValue(value) {
       		 return encode(config.json ? JSON.stringify(value) : String(value));
   		 }
   		 function parseCookieValue(s) {
       		 if (s.indexOf('"') === 0) {
           		 // This is a quoted cookie as according to RFC2068, unescape...
           		 s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
       		 }
       		 try {
           		 // Replace server-side written pluses with spaces.
           		 // If we can't decode the cookie, ignore it, it's unusable.
           		 // If we can't parse the cookie, ignore it, it's unusable.
           		 s = decodeURIComponent(s.replace(pluses, ' '));
           		 return config.json ? JSON.parse(s) : s;
       		 } catch (e) {}
   		 }
   		 function read(s, converter) {
       		 var value = config.raw ? s : parseCookieValue(s);
       		 return $.isFunction(converter) ? converter(value) : value;
   		 }
   		 var config = $.cookie = function(key, value, options) {
       		 // Write
       		 if (arguments.length > 1 && !$.isFunction(value)) {
           		 options = $.extend({}, config.defaults, options);
           		 if (typeof options.expires === 'number') {
               		 var days = options.expires,
                   		 t = options.expires = new Date();
               		 t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
           		 }
           		 return (document.cookie = [
               		 encode(key), '=', stringifyCookieValue(value),
               		 options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
               		 options.path ? '; path=' + options.path : '',
               		 options.domain ? '; domain=' + options.domain : '',
               		 options.secure ? '; secure' : ''
           		 ].join(''));
       		 }
       		 // Read
       		 var result = key ? undefined : {},
           		 // To prevent the for loop in the first place assign an empty array
           		 // in case there are no cookies at all. Also prevents odd result when
           		 // calling $.cookie().
           		 cookies = document.cookie ? document.cookie.split('; ') : [],
           		 i = 0,
           		 l = cookies.length;
       		 for (; i < l; i++) {
           		 var parts = cookies[i].split('='),
               		 name = decode(parts.shift()),
               		 cookie = parts.join('=');
           		 if (key === name) {
               		 // If second argument (value) is a function it's a converter...
               		 result = read(cookie, value);
               		 break;
           		 }
           		 // Prevent storing a cookie that we couldn't decode.
           		 if (!key && (cookie = read(cookie)) !== undefined) {
               		 result[name] = cookie;
           		 }
       		 }
       		 return result;
   		 };
   		 config.defaults = {};
   		 $.removeCookie = function(key, options) {
       		 // Must not alter options, thus extending a fresh object...
       		 $.cookie(key, '', $.extend({}, options, {
           		 expires: -1
       		 }));
       		 return !$.cookie(key);
   		 };
   	 }));
   	 /*==================Jquery Cookie End===========*/
   	 /*================Countdown Timer===============*/
   	 (function() {
   		 var deadline = new Date();
   		 deadline.setMinutes(deadline.getMinutes() + 15);
   		 var date = $.cookie('date');
   		 if (date == undefined) {
       		 $.cookie('year', deadline.getFullYear());
       		 $.cookie('month', deadline.getMonth());
       		 $.cookie('date', deadline.getDate());
       		 $.cookie('hours', deadline.getHours());
       		 $.cookie('minutes', deadline.getMinutes());
       		 $.cookie('seconds', deadline.getSeconds());
   		 }
   		 if (date == undefined) {} else {
       		 deadline.setFullYear($.cookie('year'));
       		 deadline.setMonth($.cookie('month'));
       		 deadline.setDate($.cookie('date'));
       		 deadline.setHours($.cookie('hours'));
       		 deadline.setMinutes($.cookie('minutes'));
       		 deadline.setSeconds($.cookie('seconds'));
   		 }
   		 var currentTime = new Date();
   		 var timeDifference = deadline.getTime() - currentTime.getTime();
   		 if (timeDifference <= 0) {
       		 deadline = new Date();
       		 deadline.setMinutes(deadline.getMinutes() + 15);
       		 $.cookie('year', deadline.getFullYear());
       		 $.cookie('date', deadline.getDate());
       		 $.cookie('hours', deadline.getHours());
       		 $.cookie('minutes', deadline.getMinutes());
       		 $.cookie('seconds', deadline.getSeconds());
       		 $.cookie('month', deadline.getMonth());
   		 }
   		 function pad(num, size) {
       		 var s = "0" + num;
       		 return s.substr(s.length - size);
   		 }
   		 function getTimeRemaining(endtime) {
       		 var t = Date.parse(endtime) - Date.parse(new Date()),
           		 seconds = Math.floor((t / 1000) % 60),
           		 minutes = Math.floor((t / 1000 / 60) % 60),
           		 hours = Math.floor((t / (1000 * 60 * 60)) % 24),
           		 days = Math.floor(t / (1000 * 60 * 60 * 24));
       		 return {
           		 'total': t,
           		 'days': days,
           		 'hours': hours,
           		 'minutes': minutes,
           		 'seconds': seconds
       		 };
   		 }
   		 var $js_clock = $('.js-clock-x');
   		 function clock(id, endtime) {
       		 var days = document.getElementById(id + '-days')
       		 hours = document.getElementById(id + '-hours'),
           		 minutes = document.getElementById(id + '-minutes'),
           		 seconds = document.getElementById(id + '-seconds');
       		 var days_2 = document.getElementById(id + '-days')
       		 hours_2 = document.getElementById(id + '-hours'),
           		 minutes_2 = document.getElementById(id + '-minutes'),
           		 seconds_2 = document.getElementById(id + '-seconds');
       		 var timeinterval = setInterval(function() {
           		 var t = getTimeRemaining(endtime);
           		 if (t.total <= 0) {
               		 clearInterval(timeinterval);
               		 /*===========================================================*/
               		 deadline = new Date();
               		 deadline.setMinutes(deadline.getMinutes() + 15);
               		 $.cookie('year', deadline.getFullYear());
               		 $.cookie('date', deadline.getDate());
               		 $.cookie('hours', deadline.getHours());
               		 $.cookie('minutes', deadline.getMinutes());
               		 $.cookie('seconds', deadline.getSeconds());
               		 $.cookie('month', deadline.getMonth());
               		 clock('js-clock-x', deadline);
               		 /*===========================================================*/
               		 /*clearInterval(timeinterval);
               		 deadline = new Date();
               		 deadline.setMinutes(deadline.getMinutes() + 5);
               		 clock('js-clock', deadline);*/
           		 } else {
             		 $.each($js_clock, function(index){
             		 });
             		 $.each($js_clock, function(index){
               		 $(this).find('#' + id + '-days').html(pad(t.days, 2));
               		 $(this).find('#' + id + '-hours').html(pad(t.hours, 2));
               		 $(this).find('#' + id + '-minutes').html(pad(t.minutes, 2));
               		 $(this).find('#' + id + '-seconds').html(pad(t.seconds, 2));              		 
             		 });
           		 }
       		 }, 1000);
   		 }
   		 clock('js-clock-x', deadline);
   	 })();
   	 /*================Countdown Timer End===============*/

document.addEventListener('DOMContentLoaded', function () {
    const floatDownload = document.querySelector('.float-download');

    if ( floatDownload ) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 0) {
        floatDownload.style.display = 'flex';
      } else {
        floatDownload.style.display = 'none';
      }
    });
  }

  });

function onReady(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('readystatechange', function () {
      if (document.readyState === 'interactive' || document.readyState === 'complete') {
        fn();
      }
    });
  }
}

onReady(function () {
  document.addEventListener('click', function (e) {
    if (e.target.closest('.tf-v1-close-icon')) {
      document.body.classList.add('close-typeform');
      console.log('close-typeform class added to body');
    }
  });
});

